import React from 'react';
import { CommonButton } from '@Components';
import { ApplePayModalContainer } from './styles';
import { APPLE_PAY_RETRY_MODAL_CONTENT } from './constants';
import { ApplePayRetryModalProps } from './types';

const PaymentMethodRetryModal: React.FC<ApplePayRetryModalProps> = ({
  onClose,
  primaryButtonAction,
  heading = APPLE_PAY_RETRY_MODAL_CONTENT.title,
  description = APPLE_PAY_RETRY_MODAL_CONTENT.message
}: ApplePayRetryModalProps) => {
  return (
    <ApplePayModalContainer>
      <div className="apple-pay-retry-modal__content">
        <h2 className="apple-pay-retry-modal__title">{heading}</h2>
        <p className="apple-pay-retry-modal__message">{description}</p>
        <CommonButton
          className="apple-pay-retry-modal__button"
          text={APPLE_PAY_RETRY_MODAL_CONTENT.buttonText}
          type="primary"
          onClick={primaryButtonAction}
        />
        <CommonButton
          onClick={() => onClose(false)}
          className="apple-pay-retry-modal__secondary-button"
          text={APPLE_PAY_RETRY_MODAL_CONTENT.secondaryButtonText}
          type="link"
        />
      </div>
    </ApplePayModalContainer>
  );
};

export default PaymentMethodRetryModal;
